import React from 'react';
import {Navigate} from 'react-router-dom';

import ROUTES from 'constants/routes';
import {useAppSelector} from 'store';
import {tokenSelector} from 'store/auth/auth.selectors';

interface Props {
  children: React.ReactElement;
}
const AuthRoute: React.FC<Props> = ({children}: Props) => {
  const token = useAppSelector(tokenSelector);

  if (!token) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  return children;
};

export default AuthRoute;
